var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 108.812 135.243",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 108.812 135.243\" id=\"play\">\r\n<g id=\"play__x31_\">\r\n</g>\r\n<g id=\"play__x33_\">\r\n\t<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M108.812,67.477L0,134.953V0L108.812,67.477z\" />\r\n</g>\r\n<g id=\"play__x32_\">\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/play.icon
// module id = 129
// module chunks = 168707334958949